import { getStore, removeStore, setStore } from '@/utils/util'

const ACTIVATION_PENDING_KEY = 'PDA_ACTIVATION_PENDING'

export const isActivationPending = () => Boolean(getStore(ACTIVATION_PENDING_KEY))

export const markActivationPending = () => {
  setStore(ACTIVATION_PENDING_KEY, '1')
}

export const clearActivationPending = () => {
  removeStore(ACTIVATION_PENDING_KEY)
}
